/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_MONEDA,
    CASILLA_TEXTO,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React, {useEffect, useRef, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {CategoryOutlined, ManageSearch, ReceiptLongOutlined} from "@mui/icons-material";
import {ESTADOPEDIDOS} from "../../Constantes";
import Dialogo_Pedido from "../Dialogos/Dialogo_Pedido";
import Dialogo_Pedido_Productos from "../Dialogos/Dialogo_Pedido_Productos";
import {collection, or, query, where} from "firebase/firestore";
import {fire} from "../../fire";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";
import Dialogo_Pedido_Factura from "../Dialogos/Dialogo_Pedido_Factura";
import factura from '../../Recursos/ic_factura.svg'
import Tarjeta_Indicador from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Indicador";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";
import Tarjeta_Valor_Titulo_Grafica from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Valor_Titulo_Grafica";
import Dona_Limpia from "../../Modulo_Graficas/Graficas/Dona_Limpia";
import {arrConteoColPropiedadEstados} from "../../Servicios/BD/Contadores_Arr/arrConteoColPropiedadEstados";
import {arrConteoColSemanasAtrasWheres} from "../../Servicios/BD/Contadores_Arr/arrConteoColSemanasAtrasWheres";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Seccion_Pedidos = () => {
    const refe = useRef(null);
    const {sCell} = useResponsive()
    const altoGraficas = 160
    const {alto} = useObtenerAlto({contenedor: refe})
    const [enviados, setEnviados] = useState([])
    const [nuevos, setNuevos] = useState([])
    const [seguimiento, setSeguimiento] = useState([])
    const [archivados, setArchivados] = useState([])
    const [pedidosEstado, setPedidosEstado] = useState([])
    const [numSinFacturar, setNumSinFacturar] = useState(0)
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente,
        numeroFilas,
    } = useObtenerColleccionTabla2025({coleccion: 'pedidos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Pedido,
        titulo: 'Detalles del pedido',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoProductos, abrir: abrirProductos} = useDialogo({
        Componente: Dialogo_Pedido_Productos,
        titulo: 'Detalles del pedido',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoFactura, abrir: abrirFactura} = useDialogo({
        Componente: Dialogo_Pedido_Factura,
        titulo: 'Factura del pedido',
        realizado: cargarNuevamente
    })


    const buscarProducto = async (consecutivo) => {

        let q = query(collection(fire, 'pedidos'), or(where('consecutivo', '==', parseInt(consecutivo)),
            where('cc', '==', consecutivo)))
        let dox = await obtenerColeccionQuery(q)
        setData(dox.data)

    }

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'productos':
                abrirProductos(data)
                break
            case 'factura':
                abrirFactura(data)
                break
            default :
                abrir(data)
        }
    }


    useEffect(() => {

        let wEnviados = [where('estado', '==', 'Enviado')]
        arrConteoColSemanasAtrasWheres({coleccion: 'pedidos', semanasAtras: 12, wheres: wEnviados}).then((arr) => {
            console.log(arr)
            setEnviados(arr)
        })

        let wNuevos = [where('estado', '==', 'Nuevo')]
        arrConteoColSemanasAtrasWheres({coleccion: 'pedidos', semanasAtras: 12, wheres: wNuevos}).then((arr) => {
            setNuevos(arr)
        })

        let wSeguimiento = [where('estado', '==', 'Seguimiento')]
        arrConteoColSemanasAtrasWheres({coleccion: 'pedidos', semanasAtras: 12, wheres: wSeguimiento}).then((arr) => {
            setSeguimiento(arr)
        })
        let wArchivados = [where('estado', '==', 'Archivado')]
        arrConteoColSemanasAtrasWheres({coleccion: 'pedidos', semanasAtras: 12, wheres: wArchivados}).then((arr) => {
            setArchivados(arr)
        })


        arrConteoColPropiedadEstados({
            coleccion: 'pedidos',
            propiedad: 'estado',
            arrEstados: ESTADOPEDIDOS.map((it) => it.nombre)
        }).then((arr) => {
            setPedidosEstado(arr)
        })


        let wTotalEnviados = [where('estado', '==', 'Enviado')]
        let wTotalFacturados = [where('numFactura', '!=', '')]
        contarWheres({coleccion: 'pedidos', wheres: wTotalEnviados}).then((dox) => {
            if (dox.data) {
                let numEviados = dox.data

                contarWheres({coleccion: 'pedidos', wheres: wTotalFacturados}).then((des) => {
                    if (des.res) {
                        let numFacturas = des.data
                        console.log(numEviados, numFacturas)
                        setNumSinFacturar(numEviados - numFacturas)
                    }
                })

            }
        })


    }, []);
    return (

        <Grid2 container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoProductos/>

                <DialogoFactura/>

                <Grid2 ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Pedidos'}
                        subtitulo={'Ultimas 12 semanas'}
                        Grafica={Linea_Limpia}
                        marginTop={12}
                        height={altoGraficas}
                        series={
                            [
                                {
                                    name: 'Enviados',
                                    data: enviados.map((it) => it.cantidad)

                                },
                                {
                                    name: 'Nuevos',
                                    data: nuevos.map((it) => it.cantidad)

                                },
                                {
                                    name: 'Seguimiento',
                                    data: seguimiento.map((it) => it.cantidad)

                                },
                                {
                                    name: 'Archivados',
                                    data: archivados.map((it) => it.cantidad)

                                },

                            ]
                        }
                        labels={enviados.map((it) => it.nombre)}/>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 3, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Valor_Titulo_Grafica valor={'Pedidos'}
                                                  titulo={'Totales'}
                                                  height={altoGraficas - (sCell ? -20 : 40)}
                                                  Grafica={Dona_Limpia}
                                                  marginTop={-20}
                                                  px={1}
                                                  series={pedidosEstado.map((it) => it.cantidad)}
                                                  labels={pedidosEstado.map((it) => it.nombre)}/>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Indicador icono={factura} color={'#495BFF'} titulo={'Enviados sin Factura'}
                                       valor={numSinFacturar}/>
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de pedidos'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        //  clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        numeroFilas={numeroFilas}
                        funcionBuscar={buscarProducto}
                        //  botones={[]}
                    />
                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Seccion_Pedidos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
    {
        nombre: 'Ciudad',
        direccion: 'asc',
        propiedad: 'ciudad'
    },
]

const datosCabecera = [
    {
        nombre: 'Numero',
        direccion: 'left',
        propiedades: ['consecutivo', 'ciudad'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        titulo: 'cc',
        tipo: CASILLA_TITULO_DATO
    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        tipo: CASILLA_MONEDA

    },
    {
        nombre: '# Factura',
        direccion: 'left',
        propiedad: 'numFactura',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOPEDIDOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Productos',
        id: 'productos',
        icono: CategoryOutlined
    },
    {
        nombre: 'Factura',
        id: 'factura',
        icono: ReceiptLongOutlined
    },
]